import PropTypes from 'prop-types';
import { BlockLabel, InlineLabel, Spinner } from '@celltrak/ui-components';

import useOverviewTab from './hooks';
import styles from './OverviewTab.module.scss';

const OverviewTab = ({ isLoading }) => {
  const { overviewInfo, agency, partner } = useOverviewTab();

  const renderSpinner = () => (
    <div className={styles.spinnerContainer}>
      <Spinner>Loading...</Spinner>
    </div>
  );

  const renderOverviewInfo = () => (
    <BlockLabel>
      <InlineLabel label="Visit ID:" value={overviewInfo.visitID} />
      <InlineLabel label="Reference Number:" value={overviewInfo.referenceNumber} />
      <InlineLabel label="Agency Name:" value={agency} />
      <InlineLabel label="Partner Name:" value={partner} />
      <InlineLabel label="Payer ID:" value={overviewInfo.payerID} />
      <InlineLabel label="Aggregator ID:" value={overviewInfo.aggregatorID} />
      <InlineLabel label="Received On:" value={overviewInfo.receivedOn} />
      <InlineLabel label="Modified On:" value={overviewInfo.modifiedOn} />
      <InlineLabel label="Status:" value={overviewInfo.status} />
      <InlineLabel label="Payer Status:" value={overviewInfo.payerStatus} />
      <InlineLabel label="Payer Visit Receipt:" value={overviewInfo.payerVisitReceiptID} />
      <InlineLabel label="Payer Staff Receipt:" value={overviewInfo.payerStaffReceiptID} />
      <InlineLabel label="Payer Patient Receipt:" value={overviewInfo.payerPatientReceiptID} />
      <InlineLabel label="FTP File Name:" value={overviewInfo.ftpFileName} />
      <InlineLabel label="Sent On:" value={overviewInfo.sentOn} />
      <InlineLabel label="Status Checked On:" value={overviewInfo.statusCheckedOn} />
      <InlineLabel label="Error Message:" value={overviewInfo.errorMessage} />
    </BlockLabel>
  );

  return (
    <div className={styles.overviewTab}>{isLoading ? renderSpinner() : renderOverviewInfo()}</div>
  );
};

OverviewTab.propTypes = {
  isLoading: PropTypes.bool,
};

OverviewTab.defaultProps = {
  isLoading: true,
};

export default OverviewTab;
